import ApiService from "@/core/services/api.service";
import {consultarRelacaoFluxo} from '../consultaRelacaoFluxo';
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getOpcoesBuscaContasPaciente() {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/opcoesBusca', {}, {timeout:60000});
        if (data?.resultado !== true || !Array.isArray(data.UNIDADES) || typeof data.TODAS_UNIDADES !== 'boolean')
            throw new Error(data?.erro || 'Não foi possível consultar as unidades permitidas. Tente novamente.');
        return data;
    },
    async getGraficosContasPaciente(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/graficos', dados, {timeout:60000});
        if (data?.resultado !== true || !['PLANOS','CONVENIOS','MEDICOS','UNIDADES'].every(grupo => Array.isArray(data[grupo])))
            throw new Error(data?.erro || 'Não foi possível carregar os gráficos das contas. Tente novamente.');
        return data;
    },
    async contaGastos(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        let data;
        try { ({data} = await ApiService.postOnce('contasPaciente/access/gastosMatMed', dados, {timeout: 120000})); }
        catch (erro) { erro.pendente = dados.ACAO === 'gravar'; throw erro; }
        if (data?.resultado !== true || (dados.ACAO === 'gravar' && (data.SALVO !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA)))) {
            const erro = new Error(data?.MENSAGEM_ITEM || data?.erro || 'Não foi possível consultar os gastos da conta. Tente novamente.');
            erro.item = data?.ITEM || null;
            erro.pendente = data?.PENDENTE === true || (dados.ACAO === 'gravar' && data?.resultado === true);
            throw erro;
        }
        return data;
    },
  async obterReciboDmedConta(context, pedido) {
    if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente no sistema.');
    ApiService.setHeader();
    const {data} = await ApiService.postOnce('contasPaciente/access/opcoesReciboDmed', pedido, {timeout: 30000});
    if (data?.resultado !== true || String(data.ID_PACIENTE_CONTA) !== String(pedido.ID_PACIENTE_CONTA) || !Array.isArray(data.PAGAMENTOS) || !data.CAMPOS || !data.VERSAO)
      throw new Error(data?.erro || 'Não foi possível consultar os dados do recibo DMed. Tente novamente.');
    return data;
  },
  async salvarReciboDmedConta(context, pedido) {
    if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente no sistema.');
    ApiService.setHeader();
    const {data} = await ApiService.postOnce('contasPaciente/access/salvarReciboDmed', pedido, {timeout: 60000});
    if (data?.resultado !== true || String(data.ID_PACIENTE_CONTA) !== String(pedido.ID_PACIENTE_CONTA))
      throw new Error(data?.erro || 'Não foi possível confirmar a gravação do recibo DMed. Mantenha esta tela aberta e tente salvar novamente.');
    return data;
  },
    async obterOpcoesTransferenciaItensConta(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/opcoesTransferenciaItens', {ID_PACIENTE_CONTA:idConta}, {timeout:60000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(idConta) || !Array.isArray(data.ITENS) || !Array.isArray(data.CONTAS) || !Array.isArray(data.UNIDADES))
            throw new Error(data?.erro || 'Não foi possível consultar os itens para transferência. Tente novamente.');
        return data;
    },
    async transferirItensConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/transferirItens', dados, {timeout:120000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA) || !(Number(data.ID_CONTA_DESTINO) > 0) || Number(data.TRANSFERIDOS) !== dados.ITENS.length)
            throw new Error(data?.erro || 'Não foi possível confirmar a transferência dos itens. Atualize a conta antes de tentar novamente.');
        return data;
    },
    async recalcularValorConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/recalcularConta', dados, {timeout:120000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA))
            throw new Error(data?.erro || 'Não foi possível confirmar o recálculo. Atualize a conta e confira os valores antes de tentar novamente.');
        return data;
    },
    async obterOpcoesTransferenciaUnidadeConta(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/opcoesTransferenciaUnidade', {ID_PACIENTE_CONTA: idConta}, {timeout:30000});
        if (data?.resultado !== true || !Array.isArray(data.UNIDADES))
            throw new Error(data?.erro || 'Não foi possível consultar as unidades. Tente novamente.');
        return data;
    },
    async transferirUnidadeConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/transferirUnidade', dados, {timeout:dados.TRANSFERIR_ITENS === true ? 120000 : 30000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA) || Number(data.ID_UNIDADE) !== Number(dados.ID_UNIDADE)
            || (dados.TRANSFERIR_ITENS === true && (data.ITENS_TRANSFERIDOS !== true || !(data.RECALCULADOS > 0))))
            throw new Error(data?.erro || 'Não foi possível confirmar a transferência. Confira a unidade da conta antes de tentar novamente.');
        return data;
    },
    async obterOpcoesTransferenciaClassificacaoGuiaConta(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/opcoesTransferenciaClassificacaoGuia', {ID_PACIENTE_CONTA:idConta}, {timeout:30000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(idConta) || !Array.isArray(data.CLASSIFICACOES))
            throw new Error(data?.erro || 'Não foi possível consultar as classificações de guia. Tente novamente.');
        return data;
    },
    async transferirClassificacaoGuiaConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/transferirClassificacaoGuia', dados, {timeout:30000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA) || Number(data.ID_CLASSIFICA_GUIA) !== Number(dados.ID_CLASSIFICA_GUIA))
            throw new Error(data?.erro || 'Não foi possível confirmar a transferência. Atualize a conta e confira a classificação de guia antes de tentar novamente.');
        return data;
    },
    async obterListaSolicitacoes(context,dados) {
        if(!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/listaSolicitacoes',dados,{timeout:60000});
        if(data?.TIPO!=='lista_solicitacoes' || !Array.isArray(data.ITENS) || !data.ITENS.length) throw new Error(data?.erro || 'Não foi possível carregar a listagem.');
        return data;
    },
    async validarListaSolicitacoes(context,dados) {
        if(!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/validarListaSolicitacoes',dados,{timeout:30000});
        if(data?.VALIDA!==true) throw new Error(data?.erro || 'Atualize os exames selecionados.');
        return true;
    },
    async obterAssinaturaListaSolicitacoes(context,id) {
        if(!id) return '';
        if(!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('staffMedicos/access/obterMedicoImagens',{ID_MEDICO:id},{timeout:20000});
        if(!data || data.erro) throw new Error('Não foi possível carregar a assinatura do solicitante.');
        return data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || '';
    },
    async obterFontesSolicitacaoAgenda(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/fontesSolicitacaoAgenda',dados,{timeout:30000});
        if (!Number.isInteger(data?.agendados) || !Number.isInteger(data?.solicitados)) throw new Error(data?.erro || 'Não foi possível consultar as origens da solicitação.');
        return data;
    },
    async obterSolicitacoesPendentesTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/solicitacoesPendentes',dados,{timeout:30000});
        if (!Array.isArray(data)) throw new Error(data?.erro || 'Não foi possível carregar os exames pendentes.');
        return data;
    },
    async obterGuiaSolicitacaoSadtTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/solicitacaoSadt',dados,{timeout:60000});
        if (data?.TIPO_GUIA!=='solicitacao_sadt' || !data.CAMPOS || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || !Array.isArray(data.PENDENCIAS)) throw new Error(data?.erro || 'Não foi possível preparar a solicitação.');
        return data;
    },
    async obterGuiaSolicitacaoInternacaoTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/solicitacaoInternacao',dados,{timeout:60000});
        if(data?.TIPO_GUIA!=='solicitacao_internacao' || !data.CAMPOS || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || !Array.isArray(data.PENDENCIAS)) throw new Error(data?.erro || 'Não foi possível preparar a internação.');
        return data;
    },
    async obterGuiaSolicitacaoSus(context, dados) {
        const rotas={sus_ambulatorial:'solicitacaoSusAmbulatorial',sus_especiais:'solicitacaoSusEspeciais'};
        const rota=rotas[dados.TIPO_GUIA];
        if(!rota) throw new Error('Tipo de guia SUS inválido.');
        if(!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/'+rota,dados,{timeout:60000});
        if(data?.TIPO_GUIA!==dados.TIPO_GUIA || !data.CAMPOS || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || !Array.isArray(data.PENDENCIAS)) throw new Error(data?.erro || 'Não foi possível preparar a guia SUS.');
        return data;
    },
    async obterUnidadesInternacaoTiss() {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/unidadesInternacao',{}, {timeout:30000});
        if(!Array.isArray(data)) throw new Error(data?.erro || 'Não foi possível consultar as unidades.');
        return data;
    },
    async validarSolicitacaoSadtTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/validarSolicitacaoSadt',dados,{timeout:30000});
        if (data?.VALIDA!==true) throw new Error(data?.erro || 'Atualize a lista de exames antes de imprimir.');
        return true;
    },
    async getContasPaciente(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/listar', {...dados, pagina: dados.pagina || 1, quantidadePorPagina: dados.quantidadePorPagina || 25}, {timeout: 60000});
        if (data?.PERMITIDO === false) throw new Error('Usuário sem permissão para consultar a conta.');
        if (data?.resultado === false || !Array.isArray(data?.REGISTROS) || !Number.isFinite(Number(data.QUANTIDADE))) throw new Error(data?.erro || 'Não foi possível consultar as contas. Tente novamente.');
        return data;
    },
    async getContasPacienteItens(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce("contasPaciente/access/listarItensConta", {ID_PACIENTE_CONTA: idConta}, {timeout:30000});
        return data;
    },
    async getContasPacienteProcedimentos(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.post("contasPaciente/access/listarProcedimentosConta", { ID_PACIENTE_CONTA: idConta });
        return data;
    },
    async getContaProdutosFisicos(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/listarProdutosFisicosConta', {ID_PACIENTE_CONTA:idConta}, {timeout:30000});
        if (data?.resultado !== true || !Array.isArray(data.REGISTROS)) throw new Error(data?.erro || 'Não foi possível consultar os produtos da conta. Tente novamente.');
        return data.REGISTROS;
    },
    async getContaCobrancas(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/listarCobrancasConta', {ID_PACIENTE_CONTA: idConta}, {timeout: 30000});
        if (data?.resultado !== true || !Array.isArray(data.REGISTROS) || !data.TOTAIS) throw new Error(data?.erro || 'Não foi possível consultar as cobranças da conta. Tente novamente.');
        return data;
    },
    async getContasPacienteStaff(context, idConta) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.post("contasPaciente/access/listarStaffMedicoConta", { ID_PACIENTE_CONTA: idConta });
        return data;
    },
    getContasPacienteItemStaffs(context, idFaturamento) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("contasPaciente/access/listarStaffItemConta", {ID_FATURAMENTO: idFaturamento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getContasPacienteFluxoDeCaixa(context, dados) {
        return consultarRelacaoFluxo('contasPaciente/access/listarItensContaPorFluxoDeCaixa', dados);
    },
    async getContaPaciente(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.post("contasPaciente/access/obter", dados);
        return data;
    },
    getContaPacienteSimples(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("contasPaciente/access/obterContaSimples", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async getItemProduto(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("contasPaciente/access/obterProduto", { ID_PRODUTO_MOVIMENTACAO: dados.id, componente: dados.componente }, {timeout:30000});
        return data;
    },
    async getItemProcedimento(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("contasPaciente/access/obterProcedimento", { ID_FATURAMENTO: dados.id, componente: dados.componente }, {timeout:30000});
        return data;
    },
    async getItemProcedimentoStaff(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.post("contasPaciente/access/obterStaff", { ID_FATURAMENTO_STAFF_MEDICO: dados.id, componente: dados.componente });
        return data;
    },
    async calcularPrecoItem(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('agendamentos/access/calcularPrecoItem', dados, {timeout:60000});
        return data;
    },
    getCreditoPaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("contasPaciente/access/obterCreditoPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },     
    async listaGuias(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/listaGuiasTiss", dados, { timeout: 60000 });
        return data;
    },
    async obterOpcoesGuiasTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada.');
        if (!dados.ID_PACIENTE_CONTA) return {TIPOS_GUIA:[],ERROS:[],AVISOS:[]};
        ApiService.setHeader();
        const {data}=await ApiService.postOnce('guiasTiss/access/tiposDisponiveis',{ID_PACIENTE_CONTA:dados.ID_PACIENTE_CONTA},{timeout:60000});
        if (!Array.isArray(data?.TIPOS_GUIA)) throw new Error(data?.erro || 'Não foi possível consultar os tipos de guia da conta.');
        return {...data,TIPOS_GUIA:[...new Set(data.TIPOS_GUIA)],ERROS:[]};
    },
    async obterGuiaOpmeTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/opme", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "opme" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !Array.isArray(p.MATERIAIS) || p.MATERIAIS.length > 6)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Solicitação de OPME.");
        }
        return data;
    },
    async obterGuiaOutrasDespesasTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/outrasDespesas", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "outras_despesas" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !Array.isArray(p.DESPESAS) || p.DESPESAS.length > 10 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Outras Despesas.");
        }
        return data;
    },
    async obterGuiaHonorariosMedicosTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/honorariosMedicos", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "honorarios" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || data.ORIGEM_GUIA !== "conta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !p.CAMPOS || !Array.isArray(p.EXECUTADOS) || p.EXECUTADOS.length > 10 || !Array.isArray(p.EQUIPE) || p.EQUIPE.length > 5 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Honorários Médicos.");
        }
        return data;
    },
    async obterGuiaOdontologicaTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/odontologica", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "odontologica" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || data.ORIGEM_GUIA !== "conta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !p.CAMPOS || !Array.isArray(p.PROCEDIMENTOS) || p.PROCEDIMENTOS.length > 20 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Tratamento Odontológico.");
        }
        return data;
    },
    async obterGuiaResumoInternacaoTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/resumoInternacao", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "resumo_internacao" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || data.ORIGEM_GUIA !== "conta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !p.CAMPOS || !Array.isArray(p.EXECUTADOS) || p.EXECUTADOS.length > 10 || !Array.isArray(p.EQUIPE) || p.EQUIPE.length > 8 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Resumo de Internação.");
        }
        return data;
    },
    async obterGuiaSolicitacaoInternacaoContaTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/solicitacaoInternacaoConta", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "solicitacao_internacao" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || data.ORIGEM_GUIA !== "conta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !p.CAMPOS || !Array.isArray(p.SOLICITADOS) || p.SOLICITADOS.length > 12)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Solicitação de Internação.");
        }
        return data;
    },
    async obterGuiaSolicitacaoSadtContaTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/solicitacaoSadtConta", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "solicitacao_sadt" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || data.ORIGEM_GUIA !== "conta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !Array.isArray(p.EXECUTADOS) || p.EXECUTADOS.length > 5 || !Array.isArray(p.SOLICITADOS) || p.SOLICITADOS.length > 5 || !Array.isArray(p.EQUIPE) || p.EQUIPE.length > 4 || !Array.isArray(p.SESSOES) || p.SESSOES.length > 10 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de Solicitação de SP/SADT.");
        }
        return data;
    },
    async obterGuiaSadtHonorariosTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/sadtHonorarios", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "sadt_honorarios" || String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !Array.isArray(p.EXECUTADOS) || p.EXECUTADOS.length > 5 || !Array.isArray(p.SOLICITADOS) || p.SOLICITADOS.length > 5 || !Array.isArray(p.EQUIPE) || p.EQUIPE.length > 4 || !Array.isArray(p.SESSOES) || p.SESSOES.length > 10 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia SADT de Honorários Médicos.");
        }
        return data;
    },
    async obterGuiaSadtTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/sadt", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "sadt" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS) || !Array.isArray(data.PAGINAS) || !data.PAGINAS.length || data.PAGINAS.some(p => !Array.isArray(p.EXECUTADOS) || p.EXECUTADOS.length > 5 || !Array.isArray(p.SOLICITADOS) || p.SOLICITADOS.length > 5 || !Array.isArray(p.EQUIPE) || p.EQUIPE.length > 4 || !Array.isArray(p.SESSOES) || p.SESSOES.length > 10 || !p.TOTAIS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia SP/SADT.");
        }
        return data;
    },
    async obterGuiaConsultaTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente para visualizar a guia.");
        ApiService.setHeader();
        let resposta;
        try { resposta = await ApiService.postOnce("guiasTiss/access/consulta", {
            ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA,
            ...(dados.VERSAO_TISS ? { VERSAO_TISS: dados.VERSAO_TISS } : {})
        }, { timeout: 60000 }); }
        catch (erro) {
            if (erro.response?.data?.erro) throw new Error(erro.response.data.erro);
            if (erro.response?.status === 404) throw new Error("A rota da guia não existe no backend configurado. Confira se o novo backend foi publicado.");
            if (erro.code === "ECONNABORTED") throw new Error("O servidor demorou demais para preparar a guia. Tente novamente.");
            if (erro.message === "Network Error" || erro.code === "ERR_NETWORK") {
                throw new Error("Não foi possível acessar o backend da guia (" + ApiService.getBackendUrl() + "). Confira o endereço configurado e a disponibilidade do PHP; uma falha de CORS também pode impedir a resposta.");
            }
            throw erro;
        }
        const { data } = resposta;
        if (!data || data.TIPO_GUIA !== "consulta" || !data.CAMPOS || !Array.isArray(data.PENDENCIAS)) {
            throw new Error(data?.erro || "Não foi possível obter os dados da guia de consulta.");
        }
        return data;
    },
    async obterAssinaturaPacienteTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada.");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("guiasTiss/access/obterAssinaturaPaciente", (dados.ID_PACIENTE_CONTA ? { ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA } : { ID_PACIENTE: dados.ID_PACIENTE }), { timeout: 20000 });
        if (!data || (dados.ID_PACIENTE_CONTA ? String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) : String(data.ID_PACIENTE) !== String(dados.ID_PACIENTE)) || typeof data.VALIDA_HOJE !== "boolean" || typeof data.FIRMA !== "string" || (data.VALIDA_HOJE && (!data.FIRMA || data.FIRMA_DATA !== data.DATA_ATUAL)) || (!data.VALIDA_HOJE && data.FIRMA)) {
            throw new Error(data?.erro || "Não foi possível conferir a assinatura do paciente.");
        }
        return data;
    },
    async salvarAssinaturaPacienteTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada.");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("guiasTiss/access/salvarAssinaturaPaciente", { ...(dados.ID_PACIENTE_CONTA ? { ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA } : { ID_PACIENTE: dados.ID_PACIENTE }), FIRMA: dados.FIRMA }, { timeout: 30000 });
        if (!data || (dados.ID_PACIENTE_CONTA ? String(data.ID_PACIENTE_CONTA) !== String(dados.ID_PACIENTE_CONTA) : String(data.ID_PACIENTE) !== String(dados.ID_PACIENTE)) || data.VALIDA_HOJE !== true || !data.FIRMA || data.FIRMA_DATA !== data.DATA_ATUAL) {
            throw new Error(data?.erro || "Não foi possível confirmar a assinatura salva. Atualize a guia para conferir.");
        }
        return data;
    },
    async obterImagensGuiaSadtTiss(context, guia) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada.");
        ApiService.setHeader();
        const imagens = { logo: "", paciente: "", executante: "", avisos: [] };
        const ler = async (url, dados) => {
            const { data } = await ApiService.postOnce(url, dados, { timeout: 20000 });
            if (!data || data.erro || data.resultado === false) throw new Error("Imagem indisponível");
            return data;
        };
        const tarefas = [{ nome: "logotipo do convênio", executar: async () => {
            const data = await ler("convenios/access/obterFoto", { ID_CONVENIO: guia.ID_CONVENIO });
            imagens.logo = data.FOTO || "";
        } }];
        if (!["honorarios", "outras_despesas", "opme"].includes(guia.TIPO_GUIA)) tarefas.push({ nome: "assinatura do beneficiário", executar: async () => {
            const assinatura = await context.dispatch("obterAssinaturaPacienteTiss", { ID_PACIENTE_CONTA: guia.ID_PACIENTE_CONTA, ID_PACIENTE: guia.ID_PACIENTE });
            imagens.paciente = assinatura.FIRMA;
        } });
        if (guia.TIPO_GUIA === 'opme' && guia.ASSINATURAS?.SOLICITANTE && guia.ID_MEDICO_SOLICITANTE) tarefas.push({nome:'assinatura do solicitante',executar:async()=>{
            const data=await ler('staffMedicos/access/obterMedicoImagens',{ID_MEDICO:guia.ID_MEDICO_SOLICITANTE});
            imagens.solicitante=data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || '';
        }});
        if (['honorarios','sadt_honorarios'].includes(guia.TIPO_GUIA) && guia.ASSINATURAS?.EXECUTANTE) {
            imagens.executantes = {};
            [...new Set(guia.PAGINAS.map(p => p.ID_MEDICO_EXECUTANTE).filter(Boolean))].forEach(id => tarefas.push({nome:'assinatura do executante', executar:async()=>{
                const data=await ler('staffMedicos/access/obterMedicoImagens',{ID_MEDICO:id});
                imagens.executantes[id]=data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || '';
            }}));
        }
        if (guia.ASSINATURAS?.EXECUTANTE && guia.PROFISSIONAL_EXECUTANTE) tarefas.push({ nome: "assinatura do executante", executar: async () => {
            const data = await ler("staffMedicos/access/obterMedicoImagens", { NOME: guia.PROFISSIONAL_EXECUTANTE });
            imagens.executante = data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || "";
        } });
        if (guia.ORIGEM_GUIA !== 'conta' && ['solicitacao_sadt','solicitacao_internacao','sus_ambulatorial','sus_especiais'].includes(guia.TIPO_GUIA) && guia.ASSINATURAS?.SOLICITANTE) {
            imagens.solicitantes = {};
            [...new Set(guia.PAGINAS.map(p => p.ID_MEDICO_SOLICITANTE).filter(Boolean))].forEach(id => tarefas.push({nome:'assinatura do solicitante', executar:async()=>{
                const data=await ler('staffMedicos/access/obterMedicoImagens',{ID_MEDICO:id});
                imagens.solicitantes[id]=data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || '';
            }}));
        } else if (guia.ASSINATURAS?.SOLICITANTE && (guia.PROFISSIONAL_SOLICITANTE || guia.CAMPOS["15"])) tarefas.push({ nome: "assinatura do solicitante", executar: async () => {
            const data = await ler("staffMedicos/access/obterMedicoImagens", { NOME: guia.PROFISSIONAL_SOLICITANTE || guia.CAMPOS["15"] });
            imagens.solicitante = data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || "";
        } });
        const resultados = await Promise.allSettled(tarefas.map(t => t.executar()));
        resultados.forEach((r, i) => {
            if (r.status === "rejected") imagens.avisos.push("Não foi possível carregar " + tarefas[i].nome + ". Confira antes de imprimir.");
        });
        return imagens;
    },
    async obterImagensGuiaConsultaTiss(context, guia) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada.");
        ApiService.setHeader();
        const imagens = { logo: "", paciente: "", executante: "", avisos: [] };
        const ler = async (url, dados) => {
            const { data } = await ApiService.postOnce(url, dados, { timeout: 20000 });
            if (!data || data.erro || data.resultado === false) throw new Error("Imagem indisponível");
            return data;
        };
        const tarefas = [{ nome: "logotipo do convênio", executar: async () => {
            const data = await ler("convenios/access/obterFoto", { ID_CONVENIO: guia.ID_CONVENIO });
            imagens.logo = data.FOTO || "";
        } }];
        tarefas.push({ nome: "assinatura do beneficiário", executar: async () => {
            const assinatura = await context.dispatch("obterAssinaturaPacienteTiss", { ID_PACIENTE_CONTA: guia.ID_PACIENTE_CONTA, ID_PACIENTE: guia.ID_PACIENTE });
            imagens.paciente = assinatura.FIRMA;
        } });
        if (guia.ASSINATURAS?.EXECUTANTE && guia.CAMPOS["12"]) tarefas.push({ nome: "assinatura do executante", executar: async () => {
            const data = await ler("staffMedicos/access/obterMedicoImagens", { NOME: guia.CAMPOS["12"] });
            imagens.executante = data.IMAGEM_ASSINATURA_GUIAS || data.IMAGEM || "";
        } });
        const resultados = await Promise.allSettled(tarefas.map(t => t.executar()));
        resultados.forEach((r, i) => {
            if (r.status === "rejected") imagens.avisos.push("Não foi possível carregar " + tarefas[i].nome + ". Confira antes de imprimir.");
        });
        return imagens;
    },
    async calcularPrecoStaff(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/calcularPrecoStaff', dados, {timeout:60000});
        return data;
    }, 
    async salvarConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("contasPaciente/access/salvar", dados, { timeout: 60000 });
        return data;
    },
    async prepararStatusConta(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/prepararStatusConta', dados, {timeout:30000});
        if (data?.resultado !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA))
            throw new Error(data?.erro || 'Não foi possível consultar as opções de status da conta.');
        return data;
    },
    async salvarStatus(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('contasPaciente/access/salvarStatusConta', dados, {timeout:60000});
        if (data?.resultado !== true || data.SALVO !== true || Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA))
            throw new Error(data?.erro || 'Não foi possível confirmar a operação. Atualize a conta e confira o status antes de tentar novamente.');
        return data;
    },
    async salvarContaItem(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("contasPaciente/access/salvarItem", dados, { timeout: 60000 });
        const chave = dados.TIPOPRODUTO === 'P' ? 'ID_PRODUTO_MOVIMENTACAO' : 'ID_FATURAMENTO';
        if (data?.PERMITIDO === false || data?.SALVO !== true || data?.ERRO || data?.erro || data?.ERROS?.length ||
            !(Number(data?.[chave]) > 0) || (Number(dados[chave]) > 0 && Number(data[chave]) !== Number(dados[chave])) ||
            Number(data.ID_PACIENTE_CONTA) !== Number(dados.ID_PACIENTE_CONTA)) {
            throw new Error(data?.ERRO || data?.erro || data?.ERROS?.join('\n') ||
                (data?.PERMITIDO === false ? 'Usuário sem permissão para salvar o item da conta.' : 'Não foi possível confirmar a gravação do item. Atualize a conta antes de tentar novamente.'));
        }
        return data;
    },
      async salvarContaItemStaff(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("contasPaciente/access/salvarStaff", dados, { timeout: 60000 });
        return data;
    },
        deleteConta(context, dados) {
            return new Promise(resolve => {
                if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("contasPaciente/access/excluir", { ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA, componente: dados.componente }).then(({ data }) => {
                        resolve(data);
                    });
                }
            });
        },
        async deleteContaItem(context, dados) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce("contasPaciente/access/excluirItem", dados, {timeout:60000});
            return data;
        },
        async deleteContaItemStaff(context, dados) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce("contasPaciente/access/excluirItemStaffMedico", { ID_FATURAMENTO_STAFF_MEDICO: dados.id, componente: dados.componente }, {timeout:60000});
            return data;
        }, 
        async refazInformacoesTiss(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
        ApiService.setHeader();
        const requisicao = dados !== null && typeof dados === 'object'
            ? { ID_PACIENTE_CONTA: dados.ID_PACIENTE_CONTA, ORIGEM: dados.ORIGEM }
            : { ID_PACIENTE_CONTA: dados };
        const { data } = await ApiService.postOnce("contasPaciente/access/refazerInfoTiss", requisicao, { timeout: 60000 });
        return data;
    },
        async getContaPagamentos(context, idConta) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce("contasPaciente/access/ListarContaPagamentos", {ID_PACIENTE_CONTA: idConta}, {timeout:30000});
            return data;
        }, 
        getValorPagoConta(context, idConta) {
            return new Promise(resolve => {
                if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("contasPaciente/access/obterContaPagamento", {ID_PACIENTE_CONTA: idConta}).then(({ data }) => {
                        resolve(data);
                    });
                }
            });
        }, 
        getConfiguracoesPgtoPartic() {
            return new Promise(resolve => {
                if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.get("contasPaciente/access/obterConfiguracoesPgtoPartic").then(({ data }) => {
                        resolve(data);
                    });
                }
            });
        }, 
        async getOpcoesPagamentoParticular(context, dados) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce('contasPaciente/access/opcoesPagamentoParticular', dados, {timeout:120000});
            return data;
        },
        async incluiContaPacientePagamento(context, dados) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce('contasPaciente/access/incluiContaPagamento', dados, {timeout:120000});
            return data;
        },
        async excluiContaPacientePagamento(context, dados) {
            if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente para continuar.');
            ApiService.setHeader();
            const {data} = await ApiService.postOnce('contasPaciente/access/excluiContaPagamento', dados, {timeout:120000});
            return data;
        },
        getItensContaPorAgendas(context, dados) {
            return new Promise(resolve => {
                if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("contasPaciente/access/listarItensContaPorAgendas", dados).then(({ data }) => {
                        resolve(data);
                    });
                }
            });
        },
        GetDadosParaGuia(context, dados) {
            return new Promise(resolve => {
                if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("contasPaciente/access/obterDadosParaGuia", dados).then(({ data }) => {
                        resolve(data);
                    });
                }
             });
        }
};

export default {
    state,
    actions,
    mutations,
    getters
};
